export default async ({ collectionsApi, collectionId }) => {
  const collection = await collectionsApi.get(collectionId)

  return Object.entries(collection.fields).map(([key, value]) =>
    Object.assign(value, { name: key, label: value.displayName }),
  )
}
